import React from "react";
import VariantGenericSkeleton from "./VariantGenericSkeleton";

function VariantDetailSkeleton() {
  return (
    <>
      <VariantGenericSkeleton />
    </>
  );
}

export default VariantDetailSkeleton;
